module.exports = __webpack_public_path__ + "media/images/lb/828-9d42dbed0d3691dd295104a623216b31.svg";